import { render, staticRenderFns } from "./commoditiesTrading.vue?vue&type=template&id=e93f3f60&scoped=true"
import script from "./commoditiesTrading.vue?vue&type=script&lang=js"
export * from "./commoditiesTrading.vue?vue&type=script&lang=js"
import style0 from "./commoditiesTrading.vue?vue&type=style&index=0&id=e93f3f60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93f3f60",
  null
  
)

export default component.exports